// swiperjs

const swiper2 = new Swiper('.section__slideshow', {
    slidesPerView: 1,
    loop: true,
    speed: 1000,
    effect: "fade",
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
    },
});